import React from 'react';

function Check48(props) {
	const fill = props.fill || 'currentColor';
	const secondaryfill = props.secondaryfill || fill;
	const strokewidth = props.strokewidth || 1;
	const width = props.width || '100%';
	const height = props.height || '100%';
	const title = props.title || "check 48";

	return (
		<svg height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
	<title>{title}</title>
	<g fill={secondaryfill} stroke={secondaryfill} strokeLinecap="round" strokeLinejoin="round" strokeWidth={strokewidth}>
		<path d="M3,25l4-4,9,6A123.367,123.367,0,0,1,43,8l2,4A88.987,88.987,0,0,0,16,40Z" fill="none" stroke={fill}/>
	</g>
</svg>
	);
};

export default Check48;